import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"

import { Container, Row, Col } from "ui-Grid"
import { Title } from "ui-Text"
import Button from "@material-ui/core/Button"
import Icon from "@material-ui/core/Icon"

const styleSheet = theme => ({
  root: {
    paddingTop: theme.spacing.unit * 8,
    paddingBottom: theme.spacing.unit * 8,
  },

  icon: {
    "&&": {
      fontSize: theme.spacing.unit * 12,
      lineHeight: 1,
      color: theme.palette.action.disabled,
    },
  },

  form: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },

  formTitle: {
    margin: [theme.spacing.unit * 3, 0],
    textAlign: "center",
  },
})

function Forms({ classes }) {
  return (
    <div className={classes.root}>
      <Container narrow>
        <Row gutterTop gutterBottom>
          <Col xs={12} sm={4}>
            <div className={classes.form}>
              <Icon className={classes.icon}>done_all</Icon>
              <Title className={classes.formTitle}>Consent Form</Title>
              <Button href="/forms/consent.pdf" target="_blank" download variant="outlined">
                Download &amp; Sign
              </Button>
            </div>
          </Col>
          <Col xs={12} sm={4}>
            <div className={classes.form}>
              <Icon className={classes.icon}>verified_user</Icon>
              <Title className={classes.formTitle}>HIPAA Notice of Privacy Practices</Title>
              <Button href="/forms/hipaa.pdf" target="_blank" download variant="outlined">
                Download
              </Button>
            </div>
          </Col>
          <Col xs={12} sm={4}>
            <div className={classes.form}>
              <Icon className={classes.icon}>pregnant_woman</Icon>
              <Title className={classes.formTitle}>Initial Patient History</Title>
              <Button
                href="https://goo.gl/forms/LcHlAZSWs9xy9ObX2"
                rel="noopener noreferrer"
                target="_blank"
                variant="outlined"
              >
                Begin Survey
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default withStyles(styleSheet)(Forms)



// WEBPACK FOOTER //
// ./src/views/pages/Landing/Forms.js